import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import type { AccessToken } from '@/configuration/tokenHandling/tokenSlice';

import { prepareHeaders } from '../../utils/prepareHeaders';
import { Response } from '../config/types';

export const cookieApi = createApi({
  reducerPath: 'cookieApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${import.meta.env.VITE_DOCS_URI}/cookie`,
    prepareHeaders: (headers) => {
      prepareHeaders(headers);
      headers.set('Cache-Control', 'no-cache');
      headers.set('Expires', '-1');
      return headers;
    },
  }),
  endpoints: (builder) => ({
    fetchCookies: builder.query<Response, AccessToken>({
      query: () => '',
    }),
  }),
});

export const { useFetchCookiesQuery } = cookieApi;
